import * as actions from './actions';
import reducers from './reducer';

export const Event = { actions, reducers };
export { EventState } from './reducer';
